import type { Energy, EnergyNow } from './types.js';

/** A stale "my energy now" would dim cards the next morning, so it expires. */
export const ENERGY_NOW_TTL_MS = 6 * 60 * 60 * 1000;

/** A value stamped further ahead than this came from a broken clock, not from the user. */
export const ENERGY_NOW_MAX_SKEW_MS = 60 * 60 * 1000;

/** The level in force at `now`, or null when unset or expired, meaning "any". */
export function effectiveEnergy(value: EnergyNow | null | undefined, now: number): Energy | null {
  if (!value) return null;
  if (now - value.setAt >= ENERGY_NOW_TTL_MS || value.setAt - now > ENERGY_NOW_MAX_SKEW_MS) return null;
  return value.level;
}

export function isDimmed(cardEnergy: Energy, effective: Energy | null): boolean {
  return effective !== null && cardEnergy > effective;
}

export function cycleEnergy(energy: Energy): Energy {
  return energy === 3 ? 1 : ((energy + 1) as Energy);
}
